
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {

data(){
return {
bottomCount: 20
}
},
components: {
Scroller, LoadMore
},
methods: {
onScrollBottom () {
if (this.onFetching) {

} else {
this.onFetching = true
setTimeout(() => {
this.bottomCount += 10
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
this.onFetching = false
}, 2000)
}
},
},
mounted(){

}
}



// WEBPACK FOOTER //
// ./src/project/onlineServicesProject/onlineDoctorList.vue